module.exports = __webpack_public_path__ + "img/banner-1.e191ac6a.png";